import { Injectable, inject } from '@angular/core';
import { FeatureState } from '@outlaw/core';
import { CommunityConfigService } from './community-config.service';
import { CommunityItem } from '../../interfaces/community-item';
import { AppPlatformService } from '../app-platform.service';
import { PartnerApp } from '../../interfaces/partner';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private communityConfigService = inject(CommunityConfigService);
  private appPlatformService = inject(AppPlatformService);

  private get currentApp(): PartnerApp {
    return this.communityConfigService.currentApp;
  }

  isPaywallEnabledForPlatform(item: CommunityItem): boolean {
    const app = this.appPlatformService.getAppByPlatform(item.original_platform.slug);

    return (
      this.isPaywallEnabled() &&
      // TEMPORARY: hide paywall for brandon posts
      (app !== PartnerApp.BRANDON || app === this.currentApp)
    );
  }

  isNewPlaylistEnabled(): boolean {
    return this.communityConfigService.getConfig().featureFlags?.newPlaylist === FeatureState.enabled;
  }

  isCommunityInApp(): boolean {
    return this.communityConfigService.getConfig().featureFlags?.communityInApp === FeatureState.enabled;
  }

  isCommentsEnabled(): boolean {
    return this.communityConfigService.getConfig().featureFlags?.comments === FeatureState.enabled;
  }

  isPaidPostsEnabled(): boolean {
    return this.communityConfigService.getConfig().featureFlags?.paidPosts === FeatureState.enabled;
  }

  isOpenProfileInNewWindowEnabled(): boolean {
    return this.communityConfigService.getConfig().featureFlags?.openProfileInNewWindow === FeatureState.enabled;
  }

  isShowRecommendationMessageEnabled(): boolean {
    return this.communityConfigService.getConfig().featureFlags?.showRecommendationMessage === FeatureState.enabled;
  }

  isShowProfileLinksInRecommendedByDialog(): boolean {
    return (
      this.communityConfigService.getConfig().featureFlags?.showProfileLinksInRecommendedByDialog ===
      FeatureState.enabled
    );
  }

  isShowThemeToggleEnabled(): boolean {
    return this.communityConfigService.getConfig().featureFlags?.showThemeToggle === FeatureState.enabled;
  }

  isSelectionsEnabled(): boolean {
    return this.communityConfigService.getConfig().featureFlags?.selections === FeatureState.enabled;
  }

  private isPaywallEnabled(): boolean {
    return this.communityConfigService.getConfig().featureFlags?.paywall === FeatureState.enabled;
  }
}
